import * as types from '@/store/mutation-types'
// 상단 메뉴 관리
const state = {
    pageLeftDiv  : '',
    pageMidDiv   : '',
    pageRightDiv : '',
    pageTitle    : '',
    subPageTitle : '',
    routerDiv    : '',
    routerVal    : '',
}

const getters = {
    pageLeftDiv  : state => state.pageLeftDiv,
    pageMidDiv   : state => state.pageMidDiv,
    pageRightDiv : state => state.pageRightDiv,
    pageTitle    : state => state.pageTitle,
    subPageTitle : state => state.subPageTitle,
    routerDiv    : state => state.routerDiv,
    routerVal    : state => state.routerVal,
    
}

const mutations = {
    // 페이지 구분
    [types.PAGE_LEFT_DIV](state, value) {
        state.pageLeftDiv = value;
    },
    [types.PAGE_MID_DIV](state, value) {
        state.pageMidDiv = value;
    },
    [types.PAGE_RIGHT_DIV](state, value) {
        state.pageRightDiv = value;
    },
    // 페이지 타이틀
    [types.PAGE_TITLE](state, value) {
        state.pageTitle = value;
    },
    // 서브 페이지 타이틀
    [types.SUB_PAGE_TITLE](state, value) {
        state.subPageTitle = value;
    },
    // 라우터 동작 구분
    [types.ROUTER_DIV](state, value){
        state.routerDiv = value; 
    },
    // 라우터 전달 파라미터
    [types.ROUTER_VAL](state, value){
        state.routerVal = value;
    },
}

export default {
    state,
    getters,
    mutations
}